import list from 'src/modules/sustainability/list/sustainabilityListReducers';
import form from 'src/modules/sustainability/form/sustainabilityFormReducers';
import view from 'src/modules/sustainability/view/sustainabilityViewReducers';
import destroy from 'src/modules/sustainability/destroy/sustainabilityDestroyReducers';
import importerReducer from 'src/modules/sustainability/importer/sustainabilityImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
